import type { ReactNode } from 'react';
import type { SegmentedOption } from './SegmentedControl.js';
import { SegmentedControl } from './SegmentedControl.js';
import styles from './Tabs.module.css';

export type TabItem = { value: string; label: ReactNode };

export type TabsProps = {
  items: TabItem[];
  value: string;
  onChange: (v: string) => void;
  /** Single panel (single-panel mode) */
  children?: ReactNode;
  /** Per-tab panels — preferred for multi-panel UIs */
  panels?: Record<string, ReactNode>;
};

export function Tabs({ items, value, onChange, children, panels }: TabsProps) {
  const body = panels ? panels[value] ?? null : children;
  const options: SegmentedOption<string>[] = items.map((item) => ({
    value: item.value,
    label: item.label,
  }));
  return (
    <div className={styles.root}>
      <div className={styles.tabList}>
        <SegmentedControl
          value={value}
          onChange={onChange}
          options={options}
          variant="tabs"
          aria-label="Onglets"
        />
      </div>
      <div role="tabpanel" className={styles.panel}>
        {body}
      </div>
    </div>
  );
}
